import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiCreateReseller, ApiDeleteReseller, ApiGetCustomerList, ApiGetResellerList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Select from 'react-select'
import SaveButton from "components/Button/SaveButton";

export default function Reseller(){
    const { data: resellerList, fetch: getResellerList } = useFetch(ApiGetResellerList)
    const { fetch: getCustomerList } = useFetch(ApiGetCustomerList)
    const { fetch: createReseller } = useFetch(ApiCreateReseller)
    const { fetch: deleteReseller } = useFetch(ApiDeleteReseller)

    const [resellerName, setResellerName] = useState(EmptyString)
    const [customerId, setCustomerId] = useState(EmptyString)
    const [customerOptions, setCustomerOptions] = useState(EmptyString)
    
    const resellerNameChange = (e) => {setResellerName(e.target.value)}
    const customerChange = (e) => {setCustomerId(e)}

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({isOpen: true})

        fGetCustomerList().then((res) => {
            fBindGrid(0)
            setLoading({isOpen: false})
        })
    },[])

    // Function Api Call
    async function fGetResellerList(index){
        let res

        await getResellerList({
            data: {
                resellerName: resellerName,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteReseller(resellerId){
        await deleteReseller({
            data: {
                resellerId: resellerId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCustomerList(){
        await getCustomerList({
            data: {
                customerName: EmptyString,
                address: EmptyString, 
                phone: EmptyString,
                status: StatusCodeActive,
                pageSize: 10000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "Select Customer", value: "" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].customerName.toUpperCase(), value: String(data[i].customerId) })
                    }

                    setCustomerOptions(tempArray)
                    setCustomerId(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCreateReseller(){
        await createReseller({
            data: {
                customerId: customerId.value
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { 
                    setSuccessModal({isOpen: false})
                    // navigate("/customer-card") 
                }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetResellerList(i).then((res) => {
            if (res !== null && typeof res !== 'undefined'){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = Math.ceil(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i < numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}
    const searchBtnClick = () => {
        fBindGrid(0)
    }
    const deleteBtnClick = (resellerId) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    fDeleteReseller(resellerId).then(() => {
                        fBindGrid(0)
                        setLoading({isOpen: false})
                    })
                }
            }
        })
    }
    const saveBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fCreateReseller().then(() => {
                fBindGrid(0)
                setCustomerId({label: "Select Customer", value: ""})
                setLoading({isOpen: false})
            })
        }}})
    }

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Reseller</span>
            </div>
            <hr />

            <div className="bg-white p-4 rounded shadow-sm">
                <span className="font-semibold text-xl">Add Reseller</span>
                <div className="flex my-4">
                    <div className="flex flex-col sm:flex-row sm:items-center w-full">
                        <div className="w-48">
                            <span>Reseller</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <Select options={customerOptions} value={customerId} onChange={customerChange} placeholder={"Select Customer"} />
                        </div>
                    </div>
                </div>
                <div>
                    <SaveButton onClick={saveBtnClick} visible={true} />
                </div>
            </div>

            <div className="bg-white p-4">
                <div>
                    <span className="font-semibold text-xl">Reseller List</span>
                </div>
                <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                    <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 w-full">
                        <div className="flex flex-col gap-2 w-72">
                            <span>Reseller Name</span>
                            <input className="input" value={resellerName} onChange={resellerNameChange} onKeyDown={filterEnterKeyPress} />
                        </div>
                    </div>
                    <div>
                        <div className="flex justify-end items-end h-full">
                            <SearchButton onClick={searchBtnClick} />
                        </div>
                    </div>
                </div>
            
                <div className="mt-5">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Reseller Name</th>
                                <th className="font-semibold sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {resellerList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ data.resellerName.toUpperCase() }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.resellerId)}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}